import React from 'react'

import { DownloadIcon } from '@chakra-ui/icons'
import { Button, ButtonProps } from '@chakra-ui/react'

type ButtonDownloadFromFileProps = {
  file: File
  text: string
} & ButtonProps

export const ButtonDownloadFromFile = ({
  file,
  text,
  ...props
}: ButtonDownloadFromFileProps): React.ReactElement => {
  const downloadFile = (file: File) => {
    // Create a URL for the file
    const url = window.URL.createObjectURL(file)

    // Create a temporary link element
    const a = document.createElement('a')
    a.href = url
    a.download = file.name || 'download'

    // Append the link to the body, click it, and then remove it
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)

    // Release the URL
    window.URL.revokeObjectURL(url)
  }

  return (
    <Button
      leftIcon={<DownloadIcon />}
      aria-label={text}
      onClick={() => {
        downloadFile(file)
      }}
      rounded={'full'}
      size={'md'}
      variant={'brand-solid-white'}
      alignSelf={'flex-start'}
      {...props}
    >
      {text}
    </Button>
  )
}
